import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'

class TimeInput extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      timeOpen: false,
      timeOptions: ["7:00 AM", "8:00 AM", "9:00 AM", "10:00 AM", "11:00 AM", "12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM", "5:00 PM", "6:00 PM", "7:00 PM", "8:00 PM"]
    }

    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.selectTime = this.selectTime.bind(this)
  }

  toggleDropdown() {
    this.setState({
      timeOpen: !this.state.timeOpen
    })
  }

  selectTime(time) {
    this.props.onChange(time)
    this.toggleDropdown()
  }

  renderDropdownOptions() {
    return this.state.timeOptions.map((time, i) => {
      return(
        <h4
          style={{
            color: '#03a9f4',
            padding: 10,
            backgroundColor: 'white',
            textAlign: 'center'}}
          onClick={() => this.selectTime(time)}
          key={i}>
          {time}</h4>
      )
    })
  }

  render() {
      return(
        <div
          style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <p className="label_standard">{this.props.label}</p>
            {this.props.inputError.length > 0 && <p className="input_error">{this.props.inputError}</p>}
          <div onClick={() => this.toggleDropdown()}>
            <input
              onChange={(event) => this.props.onChange(event.target.value)}
              value={this.props.value}
              disabled={true}
              className="input_standard"
              placeholder={this.props.placeholder}
            />
          </div>
          {this.state.timeOpen &&
            <div>
              <div
                className="dropdownContainer">
                {this.renderDropdownOptions()}
              </div>
            </div>}
        </div>
      )
  }
}

export default TimeInput;
